var $ = require('../internals/export');

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.github.io/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.number.max-safe-integer.js
// module id = 1743
// module chunks = 1